import React, { useEffect } from "react"
import DocumentMeta from "react-document-meta"
import { useNavigate, Link } from "react-router-dom"
import AccordionItem from "../components/elements/AccordionItem"
import Header from "../components/Header"
import Footer from "../components/Footer"

function Contact() {
	const navigate = useNavigate()

	// SEO Meta Tags

	const meta = {
		// title: "Mit merci zum Muttertag filmreif Danke sagen!",
		// canonical: "https://arvato-hawaiian-tropic-2023.de/",
		// meta: {
		// 	name: {
		// 		robots: "noindex, nofollow",
		// 	},
		// },
	}

	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		})
	}, [])

	return (
		<DocumentMeta {...meta}>
			<div className="light bg-cover">
				<Header type="logo" />
				<div className="text-back  mx-auto  py-8 ">
					<div className=" bg-[url(/src/bgimages/form-bg.png)] bg-cover py-8">
						<h2 className="h2 mb-8 mt-12 text-center font-Alpro text-2xl text-white lg:mt-24">Kontakt </h2>
					</div>
					<div className="container max-w-[90%] md:max-w-[800px] mx-auto pt-12 text-center">
						<p className="mb-4 text-blue text-[18px] md:text-[24px]" >
							Du hast eine Frage, Anregungen oder Kritik?
						</p>
						<p className="mb-4 text-blue text-[18px] md:text-[24px]" >
							Dann nimm gerne Kontakt mit uns auf. Wir freuen uns über Deine Nachricht!
						</p>
						<p className="mb-4 text-blue text-[18px] md:text-[24px]" >
							<a href="mailto:info@gratistesten.alpro.com" className="underline">info@gratistesten.alpro.com</a>
						</p>
						<p className="mb-4 text-blue text-[18px] md:text-[24px]" >
							Allgemeine Informationen zur Aktion findest du außerdem in den <Link target="_blank" to={"/faq"} className=" text-blue underline lg:mr-12">
								FAQ
							</Link>
						</p>




						<div className="text-center text-xl text-blue">
							<Link
								to="/"
								className="mb-6 mt-12 block w-[100%] bg-blue p-4 font-Alpro text-[24px] font-bold uppercase tracking-wider text-white drop-shadow-md sm:w-[auto] md:text-[32px] trackind-wider rounded-full border-[3px] border-white lg:inline-block lg:py-2 lg:px-6"
							>
								Zurück
							</Link>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</DocumentMeta>
	)
}
export default Contact
